import React, { useContext } from 'react';
import { urls } from '../..';
import { concatUrlPathnames, removeMultipleSlashes } from '../../data/sport-utils';
import { getLabel } from '../../data/labels';
import { XRouterNavigateContext } from '../../common/seo/xrouter/XRouterNavigateContext';
import { isPrematchBasePath } from '../../common/seo/xrouter/seoUtils';

export default function CalendarDropdownButton(props) {
    const xrouterNavigateContext =  useContext(XRouterNavigateContext);
    let urlCalendar;

    if(urls?.['calendar']?.startsWith(`${urls.prematch.base}`) && isPrematchBasePath(window.location.pathname)  ) {
        urlCalendar = urls?.['calendar'].replace(`${urls.prematch.base}/`,'')
    }else{
        urlCalendar =  urls?.['calendar'];
    }
    urlCalendar = removeMultipleSlashes(concatUrlPathnames(urls.basename,urlCalendar));

    return (
        <div className="shrink-0 h-[50px] grid grid-cols-12 items-center border-y border-y-cs7" onClick={() => xrouterNavigateContext.navigate(urlCalendar,{state: {}})}>
            <div className={"col-start-1 col-end-3 justify-self-center inline-flex items-center justify-center w-[24px] h-[24px]"}>
                <i className="bi-calendar text-cs1" />
            </div>
            <div className="col-start-3 col-end-13 font-medium text-sm text-cs-3">{getLabel('menu.calendar')}</div>
        </div>
    );
}
